import { render, staticRenderFns } from "./DropdownCheckboxFk.vue?vue&type=template&id=7f066854&scoped=true"
import script from "./DropdownCheckboxFk.vue?vue&type=script&lang=js"
export * from "./DropdownCheckboxFk.vue?vue&type=script&lang=js"
import style0 from "./DropdownCheckboxFk.vue?vue&type=style&index=0&id=7f066854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f066854",
  null
  
)

export default component.exports